(function () {
  const root = document.querySelector('[data-kezvion-chat]');
  if (!root) return;

  const webhook = root.dataset.webhook;
  if (!webhook) return;

  const panel = root.querySelector('.kezvion-chat__panel');
  const launcher = root.querySelector('.kezvion-chat__launcher');
  const closeBtn = root.querySelector('.kezvion-chat__close');
  const form = root.querySelector('.kezvion-chat__form');
  const input = root.querySelector('.kezvion-chat__input');
  const messages = root.querySelector('.kezvion-chat__messages');
  const sendBtn = root.querySelector('.kezvion-chat__send');

  const storageKey = 'kezvion_chat_session_id';
  let sessionId = localStorage.getItem(storageKey);
  if (!sessionId) {
    sessionId = 'kz-' + (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()));
    localStorage.setItem(storageKey, sessionId);
  }

  function setOpen(open) {
    root.dataset.open = open ? 'true' : 'false';
    launcher.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      input.focus();
    }
  }

  function appendBubble(text, role) {
    const el = document.createElement('div');
    el.className = 'kezvion-chat__bubble kezvion-chat__bubble--' + role;
    el.textContent = text;
    messages.appendChild(el);
    messages.scrollTop = messages.scrollHeight;
    return el;
  }

  function setBusy(busy) {
    input.disabled = busy;
    sendBtn.disabled = busy;
  }

  launcher.addEventListener('click', () => {
    setOpen(root.dataset.open !== 'true');
  });

  closeBtn.addEventListener('click', () => setOpen(false));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && root.dataset.open === 'true') {
      setOpen(false);
    }
  });

  if (!messages.children.length) {
    appendBubble(
      "Hi — I'm Kezvion support. Ask about products, sizing, shipping, or returns.",
      'bot'
    );
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const text = input.value.trim();
    if (!text) return;

    appendBubble(text, 'user');
    input.value = '';
    setBusy(true);

    const typing = appendBubble('Thinking…', 'bot');
    typing.classList.add('kezvion-chat__bubble--typing');

    try {
      const response = await fetch(webhook, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: text, sessionId }),
      });

      if (!response.ok) {
        throw new Error('HTTP ' + response.status);
      }

      const data = await response.json();
      const reply = typeof data.reply === 'string' ? data.reply : data.message || data.output;
      if (!reply) {
        throw new Error('Empty reply');
      }

      typing.textContent = reply;
      typing.classList.remove('kezvion-chat__bubble--typing');
    } catch (err) {
      typing.textContent =
        "Sorry — I couldn't reach support right now. Email support@kezvion.com or call +31 6 49541834.";
      typing.classList.remove('kezvion-chat__bubble--typing');
      console.error('Kezvion chat error', err);
    } finally {
      setBusy(false);
      input.focus();
    }
  });
})();
